import config from "config/config.js";

const login = (email, password) => {
  // const endpoint = `http://localhost:3000/api/login`;
  // const endpoint = `https://www.foodiestrip.com/api/login`;
  console.log(config.baseUrl);
  const endpoint = `${config.baseUrl}/api/login`;
  const data = {
    email,
    password
  };
  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Credentials": true,
      "Access-Control-Allow-Headers": true,
      "Access-Control-Allow-Methods": ["POST"],
      "Access-Control-Allow-Origin": `${config.baseUrl}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    credentials: "include",

    body: JSON.stringify(data)
  };
  return fetch(endpoint, options)
    .then(response => {
      if (response.status !== 200) {
        return null;
      }
      return response.json();
    })
    .then(response => {
      // eslint-disable-next-line no-console
      return response;
    })
    .then(response => {
      // eslint-disable-next-line no-console
      if (!response) {
        return null;
      }

      const result = {
        status: "ok",
        success: true,
        accessToken: response.accessToken,
        xsrfToken: response.xsrfToken
      };
      return result;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errore", e);
      if (e.status === 422) {
        // user not verified
        // console.log('User not verified');
        const result = {
          status: "user_not_verified",
          success: false
        };
        return result;
      } else {
        // console.log(`Error occurred while signing in: ${JSON.stringify(e)}`);
        const result = {
          status: "wrong_username_and_password",
          success: false
        };
        return result;
      }
    });
};

export default login;



// WEBPACK FOOTER //
// ./src/utils/login.js